import React from "react";
import "./Disclaimer.scss";
import PropTypes from "prop-types";

const Disclaimer = ({ DisclaimerMessage }) => {
  return (
    <div className="disclaimer-container">
      <div className="disclaimer-content">
        <div className="disclaimer-text">
          <div className="disclaimer-message">{DisclaimerMessage}</div>
        </div>
      </div>
    </div>
  );
};

Disclaimer.propTypes = {
  DisclaimerMessage: PropTypes.node.isRequired,
};

export default Disclaimer;
